// 知识图谱
import main from "../../views/mappingKnowledgeDomain/main/index.vue"; // 前台页面
export const mappingPageRouter = [
  {
    path: "/mapping",
    name: "mapping",
    component: main,
    redirect: "/mapping/KnowledgeGraph",
    children: [
      // 知识图谱
      {
        path: "/mapping/KnowledgeGraph",
        name: "KnowledgeGraph",
        component: () => import("../../views/mappingKnowledgeDomain/KnowledgeGraph/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "KnowledgeGraph", // 归属级 (头部的)
          affiliation_Left: "KnowledgeGraph", // 归属级 (左侧的)
          // skip_login: true, // 免登录 设置为true
        },
      },
      // 能力图谱
      {
        path: "/mapping/AbilityMap",
        name: "AbilityMap",
        component: () => import("../../views/mappingKnowledgeDomain/AbilityMap/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "AbilityMap", // 归属级 (头部的)
          affiliation_Left: "AbilityMap", // 归属级 (左侧的)
          // skip_login: true, // 免登录 设置为true
        },
      },
      // 问题图谱
      {
        path: "/mapping/ProblemGraph",
        name: "ProblemGraph",
        component: () => import("../../views/mappingKnowledgeDomain/ProblemGraph/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "ProblemGraph", // 归属级 (头部的)
          affiliation_Left: "ProblemGraph", // 归属级 (左侧的)
          // skip_login: true, // 免登录 设置为true
        },
      },
      // 资源图谱
      {
        path: "/mapping/ResourceMap",
        name: "ResourceMap",
        component: () => import("../../views/mappingKnowledgeDomain/ResourceMap/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "ResourceMap", // 归属级 (头部的)
          affiliation_Left: "ResourceMap", // 归属级 (左侧的)
          // skip_login: true, // 免登录 设置为true
        },
      },
    ]}
];
